import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiConnectService} from '../../services/api-connect.service';
import {LanguageSwitcher} from '../../header/language-switcher/language-switcher.model';
import {HeaderService} from '../../services/header.service';
import {TaskBarService} from '../../services/task-bar.service';
import {SidebarService} from '../../services/side-bar.service';
import {ViewDocxComponent} from '../views/view-docx/view-docx.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ViewDocxService} from '../../services/view-docx.service';

@Component({
  selector: 'app-my-standards',
  templateUrl: './my-standards.component.html',
  styleUrls: ['./my-standards.component.css']
})
export class MyStandardsComponent implements OnInit {
  isLoaded = false;
  standards: any[] = [];
  userHasNoStandardsError = false;
  internalServerProblemError = false;
  standardNotFound = false;
  language: string;
  sortDirection = true;
  currentSortId = 'number,asc';

  private userId = '';

  hideBlanks = false;

  currentSearchValue = '';
  currentPage = 0;
  p = 1; // current page for ngx-pagination
  totalItems = 0; // totalItems for ngx pagination

  constructor(private userService: UserService,
              private route: ActivatedRoute,
              private router: Router,
              private apiConnectService: ApiConnectService,
              public languageSwitcher: LanguageSwitcher,
              public sidebarService: SidebarService,
              private taskBarService: TaskBarService,
              private headerService: HeaderService,
              private modalService: NgbModal,
              public viewDocxService: ViewDocxService) {
  }

  ngOnInit() {
    this.userId = this.userService.getLocal().id;
    this.getAllStandards();

    if (JSON.parse(localStorage.getItem('User')) != null
      && JSON.parse(localStorage.getItem('User')).testing != null) {
      if (JSON.parse(localStorage.getItem('User')).testing === true) {
        // this.router.navigate(['/dashboard/testing']);

        // close sidebar
        this.sidebarService.closeSideBar();
        // close task bar
        this.taskBarService.closeTaskBar();
        // hide sidebar but in header
        this.headerService.hideSideMenu();
        // hide task bar but in header
        this.headerService.hideTaskMenu();
        // hide username in header
        this.headerService.hideUsername();

        this.hideBlanks = true;

      } else {
        this.hideBlanks = false;
      }
    }
  }

  openDocModal(docxID, sID) {
    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxID();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxID();
    });

  }


  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });
  }


  // GET STANDARDS FROM API
  getAllStandards() {
    this.userService.getStandards(this.userService.getLocal().id).subscribe(
      (standResponse: any) => {
        if (standResponse.status === 200) {
          const res = standResponse.body;
          this.standards = res.content;
          this.totalItems = res.totalElements;
          this.isLoaded = true;
        } else if (standResponse.status === 204) {
          this.userHasNoStandardsError = true;
          this.isLoaded = true;
        }
      },
      (error) => {
        this.internalServerProblemError = true;
        this.isLoaded = true;
      }
    );

  }

  // SEARCH FOR SPECIFIC VALUE
  searchValue(value) {
    this.currentSearchValue = value;
    this.searchValueAPI(value.trim());
  }

  // GET SEARCH API
  searchValueAPI(value) {
    this.userService.searchForValue(this.userId, value).subscribe(
      (standResponse: any) => {
        if (standResponse.status === 200) {
          this.standardNotFound = false;
          const res = standResponse.body;
          this.standards = res.content;
          this.totalItems = res.totalElements;
          this.isLoaded = true;
        } else if (standResponse.status === 204) {
          this.userHasNoStandardsError = true;
          this.isLoaded = true;
          this.standardNotFound = true;
        }
      },
      (error) => {
        this.internalServerProblemError = true;
        this.isLoaded = true;
      }
    );
  }

  // SORT LIST
  sortList(sortId) {
    if (this.sortDirection) {
      sortId += ',desc';
      this.currentSortId = sortId;
      this.sortDirection = !this.sortDirection;
    } else {
      sortId += ',asc';
      this.currentSortId = sortId;
      this.sortDirection = !this.sortDirection;
    }
    this.getSortedListFromAPI(sortId);
  }

  getSortedListFromAPI(sortId) {
    const pageNumb = this.p - 1;
    this.userService.getSortedList(this.userId, this.currentSearchValue.trim(), sortId, pageNumb).subscribe(
      (standResponse: any) => {
        if (standResponse.status === 200) {
          this.standardNotFound = false;
          const res = standResponse.body;
          this.standards = res.content;
          this.isLoaded = true;
        } else if (standResponse.status === 204) {
          this.userHasNoStandardsError = true;
          this.isLoaded = true;
          this.standardNotFound = true;
        }
      },
      (error) => {
        this.internalServerProblemError = true;
        this.isLoaded = true;
      }
    );
  }

  downloadFile(fileId: string) {
    this.userService.getFile(fileId).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);

        link.download = response.headers.get('filename');

        const obj_url = window.URL.createObjectURL(response.body);

        link.click();
        link.remove();
      },
      () => {
      }
    );
  }

  openPdf(fileId: string) {
    this.userService.getPdf(fileId).subscribe(
      (response: any) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.body], {type: 'application/pdf'}));
        window.open(fileURL, '_blank');
      }
    );
  }

  // GET PAGE ngx-pagination
  getPage(page: number) {
    this.getPageAPI(page);
  }

  // GET PAGE FROM API
  getPageAPI(pageNumber: number) {
    const page = pageNumber - 1;
    this.userService.getPageServer(this.userId, this.currentSearchValue.trim(), page, this.currentSortId).subscribe(
      (standResponse: any) => {
        if (standResponse.status === 200) {
          this.standardNotFound = false;
          const res = standResponse.body;
          this.standards = res.content;
          this.totalItems = res.totalElements;
          this.currentPage = res.totalPages;
          this.p = pageNumber;
          this.isLoaded = true;
        } else if (standResponse.status === 204) {
          this.userHasNoStandardsError = true;
          this.isLoaded = true;
          this.standardNotFound = true;
        }
      },
      () => {
        this.internalServerProblemError = true;
        this.isLoaded = true;
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/my-standards/my-standards.component.ts